










import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import LoadApp from "@/resources/mixins/loadApp/loadApp";
import { i18n } from "@/resources/locales";
@Component({
  name: "suggestions-component",
})
export default class SkipTutorialComponent extends mixins(LoadApp) {
  skip = i18n.t("buttons.skip");
  skipText = i18n.t("notifications.descriptions.skip");
  async skipTutorial() {}
}
